import request from '../request.js'

// 保存/修改角色数据权限信息（张卫华）
const saveRoleDataPermission = function (data) {
    return request({
        url: 'sysGroupRoleDataPermission/saveOrUpdate',
        method: 'post',
        data
    })
}

// 保存角色组织架构权限数据信息（张卫华）
const getAuthScopeData = function (data) {
    return request({
        url: 'sysGroupRoleDataPermission/getAuthScopeData',
        method: 'post',
        data
    })
}

export {
    saveRoleDataPermission,
    getAuthScopeData,
}